export default {"src":"/_next/static/media/vest.ef925e14.svg","height":181,"width":164,"blurWidth":0,"blurHeight":0};